/**
 * Ruta `/` (T020 + T018): puerta de entrada del kiosco (research R-3).
 *
 * Gate: con credencial en el store `fermin-marker` (`credential/store.ts`: `getSessionToken()`)
 * ⇒ `/pantalla`; sin credencial (o IndexedDB inaccesible) ⇒ `/activar`. No hay historial
 * navegable: ambas redirecciones usan `replace`.
 *
 * Queda para las stories: US1 escribe la credencial al activar (`setSessionToken`/`setMeSnapshot`)
 * y navega a `/pantalla`; US2/US4 hacen en `/pantalla` el `GET /me` previo al canal y reaccionan
 * a `401 TERMINAL_SESSION_REVOKED` por `details.reason`. Este gate no consulta la red.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

import { getSessionToken } from '../credential/store';

/** Decide el destino del gate a partir de si hay credencial de sesión. */
export function gateTarget(hasCredential: boolean): '/pantalla' | '/activar' {
  return hasCredential ? '/pantalla' : '/activar';
}

/** `true` si hay token en el store; cualquier fallo de almacenamiento cuenta como "sin credencial". */
export async function hasCredential(): Promise<boolean> {
  try {
    return (await getSessionToken()) !== null;
  } catch {
    return false;
  }
}

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    throw redirect({ to: gateTarget(await hasCredential()), replace: true });
  },
});
